// extracted by mini-css-extract-plugin
export var alertIcon = "_ns-0";